import "./coffeeMug.css";

export default function CoffeeMug() {
	return (
		<div className="coffee-mug-container">
			<div className="mug">
				<div className="bubble bubble-1"></div>
				<div className="bubble bubble-2"></div>
				<div className="bubble bubble-3"></div>
			</div>
		</div>
	);
}
